import { render, staticRenderFns } from "./jd-input-twonum.vue?vue&type=template&id=a9914962&scoped=true&"
import script from "./jd-input-twonum.vue?vue&type=script&lang=js&"
export * from "./jd-input-twonum.vue?vue&type=script&lang=js&"
import style0 from "./jd-input-twonum.vue?vue&type=style&index=0&id=a9914962&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9914962",
  null
  
)

export default component.exports